import React, {useState} from "react";
import "./App.css";
import {Layout, Typography} from "antd";
import SideBar, {SideBarItem} from "./components/SideBar";
import JobTable from "./components/JobTable";
import Dashboard from "./components/Dashboard";

const {Title} = Typography;
const {Header, Content} = Layout;

const SideBarItems = [
  new SideBarItem("dashboard", "Dashboard", "dashboard"),
  new SideBarItem("ai-jobs", "AI Jobs"),
  new SideBarItem("veritone-jobs-status", "Veritone Jobs Status"),
  new SideBarItem("veritone-tdo-record", "Veritone TDO Record"),
  new SideBarItem("revai-jobs-record", "Rev.ai Jobs Record"),
  new SideBarItem("amazon-jobs-record", "Amazon Video Rekognition Jobs Record"),
  new SideBarItem("ai-md-indexed-rrn", "Metadata Indexed RRN"),
  new SideBarItem("ai-vcs-indexed-rrn", "VCS Indexed RRN"),
  new SideBarItem("internal-db", "Internal DB")
];

function App(props: any) {
  const [sideBarItem, setSideBarItem] = useState(SideBarItems[0]);
  return (
    <div className="App">
      <Layout style={{ minHeight: "100vh" }}>
        <SideBar
          sideBarItems={SideBarItems}
          selectedKey={sideBarItem.getKey()}
          onSelect={item => {
            setSideBarItem(item);
          }}
        />
        <Layout>
          <Header className="header">
            <Title
              level={2}
              style={{
                backgroundColor: "#001529",
                fontSize: 30,
                color: "darkorange"
              }}
            >
              {sideBarItem.getLabel()}
            </Title>
          </Header>
          <Content>{getContent(sideBarItem)}</Content>
        </Layout>
      </Layout>
    </div>
  );
}

function getContent(item: SideBarItem) {
  switch (item.getKey()) {
    case "dashboard":
      return <Dashboard />;
    default:
      return <JobTable item={item} />;
  }
}

export default App;
